export default __webpack_public_path__ + "static/bushfire-acc918be57bbb8b99c464033a6633ff9.jpg";